import React, { useEffect, useState, useRef } from 'react'
import Button from '@material-ui/core/Button'
import Icon from 'antd/es/icon'
import { makeStyles } from "@material-ui/core/styles"
import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import Grow from "@material-ui/core/Grow"
import Paper from "@material-ui/core/Paper"
import Popper from "@material-ui/core/Popper"
import MenuItem from "@material-ui/core/MenuItem"
import MenuList from "@material-ui/core/MenuList"
import FormControl from "@material-ui/core/FormControl"
import FormLabel from "@material-ui/core/FormLabel"
import CheckIcon from "@material-ui/icons/Check"
import RefreshIcon from "@material-ui/icons/Refresh"
import IconButton from '@material-ui/core/IconButton'
import { Grid, TextField } from '@material-ui/core'

import { DatePicker } from 'antd';

import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { connect } from "react-redux"

const dateFormat = 'YYYY-MM-DD';

const TableContextMenuFilterComponent = ({ IconStyle, Module, SendToFilter, ClearFiltered, ordersFilterData, setOrdersFilterData, handleSearchMultipleBoxChange, t, hasFilter, handleInputChange, ...props }) => {
    const [open, setOpen] = useState(false)
    const anchorRef = useRef(null)
    const prevOpen = useRef(open)
    const { RangePicker } = DatePicker;
    
    function onChange(date, dateString) {

        let temp = { ...ordersFilterData }
        temp.startDate = dateString[0]
        temp.endDate = dateString[1]
        setOrdersFilterData({ ...temp })
    }
    function onChangeVIN(e) {
        const { name, value } = e.target
        let temp = { ...ordersFilterData }
        temp.vin = value;
        setOrdersFilterData({ ...temp })
    }

    function disabledDate(current) {
        return current && current > moment().endOf('day');
    }

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open])

    const useStyles = makeStyles({
        root: {
            "&:hover": {
                backgroundColor: "transparent"
            }
        },
        icon: {
            borderRadius: "50%",
            width: 16,
            height: 16,
            boxShadow:
                "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
            backgroundColor: "#f5f8fa",
            backgroundImage:
                "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
            "$root.Mui-focusVisible &": {
                outline: "2px auto rgba(19,124,189,.6)",
                outlineOffset: 2
            },
            "input:hover ~ &": {
                backgroundColor: "#ebf1f5"
            },
            "input:disabled ~ &": {
                boxShadow: "none",
                background: "rgba(206,217,224,.5)"
            }
        },
        checkedIcon: {
            backgroundColor: "#137cbd",
            backgroundImage:
                "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
            "&:before": {
                display: "block",
                width: 16,
                height: 16,
                backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
                content: '""'
            },
            "input:hover ~ &": {
                backgroundColor: "#106ba3"
            }
        },
        header: {
            minHeight: '25px',
            color: 'rgba(0, 0, 0, 0.85)',
            borderBottom: '1px solid #e8e8e8',
            marginBottom: '.5rem',
        },
        subHeader: {
            marginBottom: '.5rem',
            marginTop: '.5rem'
        },
        itemsLabel: {
            marginBottom: '-.5rem'
        }
    });

    const classes = useStyles();

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        }
    }

    const Clear = (event, Module) => {
        ClearFiltered()
    }
   
    switch (Module) {
        case "orders":
            return (
                <div className={classes.root}>
                    {/* Filter Icon Button */}
                    <Button
                        type="button"
                        variant="outlined"
                        style={IconStyle}
                        ref={anchorRef}
                        aria-controls={open ? "menu-list-grow" : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        title={t('TableOrderContextMenuFilter.ButtonFilter')}
                    >
                        <Icon type="filter" theme={hasFilter ? "filled" : "outlined"} style={{ color: '#676767' }} />
                    </Button>
                    {/* Popper Dropdown */}
                    <Popper
                        open={open}
                        anchorEl={anchorRef.current}
                        role={undefined}
                        transition
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin:
                                        placement === "bottom" ? "center top" : "center bottom"
                                }}
                            >
                                <Paper className={classes.paper}>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                            <MenuItem>
                                                <FormControl component="fieldset" >
                                                    <FormLabel component="legend" className={classes.header}>{t('TableOrderContextMenuFilter.TittleFilter')}</FormLabel>
                                                    <Grid>
                                                        {/* Date */}
                                                        <Grid item xs={12} className={classes.subHeader} style={{ fontSize: '.875rem' }}>
                                                            <b>{t('TableOrderContextMenuFilter.TittleDates')}</b>
                                                        </Grid>
                                                        <Grid item xs={12} className={classes.subHeader}>
                                                            <RangePicker
                                                                
                                                                value={ordersFilterData.startDate === '' || ordersFilterData.endDate === '' ? null :
                                                                    [moment(ordersFilterData.startDate), moment(ordersFilterData.endDate)]}
                                                                format={dateFormat}
                                                                onChange={onChange}
                                                                disabledDate={disabledDate}
                                                                placeholder={[t('TableOrderContextMenuFilter.InitialDate'), t('TableOrderContextMenuFilter.EndDate')]}
                                                                size="large"
                                                            />
                                                        </Grid>
                                                        {/* Status */}
                                                        <Grid item xs={12} className={classes.subHeader} style={{ fontSize: '.875rem' }}>
                                                            <b>{t('TableOrderContextMenuFilter.Status')}</b>
                                                        </Grid>
                                                        <Grid item xs={12} className={classes.subHeader}>
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                options={props.status}
                                                                getOptionLabel={(option) => option.description}
                                                                value={[...ordersFilterData.status]}
                                                                style={{ backgroundColor: '#fff' }}
                                                                onChange={(event, newValue) => {
                                                                    handleSearchMultipleBoxChange(newValue, 'status')
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField {...params} variant="outlined" size="small" placeholder={t('TableOrderContextMenuFilter.SelectStatus')} />
                                                                )}
                                                            />
                                                        </Grid>
                                                        {/* Service */}
                                                        <Grid item xs={12} className={classes.subHeader} style={{ fontSize: '.875rem' }}>
                                                            <b>{t('TableOrderContextMenuFilter.Service')}</b>
                                                        </Grid>
                                                        <Grid item xs={12} className={classes.subHeader}>
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                options={props.contractServiceCode}
                                                                getOptionLabel={(option) => option.contractSvcDesc}
                                                                value={[...ordersFilterData.service]}
                                                                onChange={(event, newValue) => {
                                                                    handleSearchMultipleBoxChange(newValue, 'service')
                                                                }}
                                                                style={{ backgroundColor: '#fff' }}
                                                                renderInput={(params) => (
                                                                    <TextField {...params} variant="outlined" size="small" placeholder={t('TableOrderContextMenuFilter.SelectService')} />
                                                                )}
                                                            />
                                                        </Grid>
                                                        {/* VIN */}
                                                        <Grid item xs={12} className={classes.subHeader} style={{ fontSize: '.875rem' }}>
                                                            <b>{t('TableOrderContextMenuFilter.VIN')}</b>
                                                        </Grid>
                                                        <Grid item xs={12} className={classes.subHeader}>
                                                            <TextField id="vin" style={{ backgroundColor: "white" }} type="text" variant="outlined" size="small" fullWidth
                                                                inputProps={{ maxLength: 17 }}
                                                                placeholder={t('TableOrderContextMenuFilter.CaptureVIN')} maxLength={17} value={ordersFilterData.vin}
                                                                onChange={onChangeVIN} />
                                                        </Grid>
                                                        {/* Divider */}
                                                        <Grid item xs={12}>
                                                            <div style={{ borderBottom: '1px solid #e8e8e8', marginTop: 15 }} />
                                                        </Grid>
                                                    </Grid>
                                                </FormControl>
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                    {/* Action Buttons */}
                                    <Grid container justifyContent="flex-end" spacing={1} style={{ padding: 8 }}>
                                        <Grid item>
                                            <IconButton
                                                style={{ color: 'green' }}
                                                title={t('TableOrderContextMenuFilter.ApplyFilters')}
                                                onClick={SendToFilter}
                                            >
                                                <CheckIcon fontSize="large" />
                                            </IconButton>
                                        </Grid>
                                        <Grid item>
                                            <IconButton
                                                style={{ color: 'blue' }}
                                                title={t('TableOrderContextMenuFilter.CleanFilters')}
                                                onClick={(event) => Clear(event, Module)}
                                            >
                                                <RefreshIcon fontSize="large" />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </div >
            )
        default:
            break;
    }

}

const mapStateToProps = state => ({
    status: state.CatalogReducer.Status,
    contractServiceCode: state.CatalogReducer.ContractServiceCode
})


const mapDispatchToProps = (dispatch) => {
    return {
        tokenExpired: () => dispatch({ type: "TOKEN_EXPIRED" })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TableContextMenuFilterComponent)
